import { Card } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { FormikMoneyCell } from "@/features/forms/components/formik-controls";

// (line label, row-key prefix, isInteger). Mirrors the 8379 Part III rows 13a–20
// and the backend mapper's row prefixes; num_exmp (row 16) is a whole count.
const ROWS: { line: string; label: string; prefix: string; integer?: boolean }[] = [
  { line: "13a", label: "Income reported on the return", prefix: "inc_rep" },
  { line: "13b", label: "All other income", prefix: "all_oth_inc" },
  { line: "14", label: "Adjustments to income", prefix: "adj_inc" },
  { line: "15", label: "Standard deduction or itemized deductions", prefix: "std_ded" },
  { line: "16", label: "Number of exemptions", prefix: "num_exmp", integer: true },
  { line: "17", label: "Credits (do not include the earned-income credit)", prefix: "credit" },
  { line: "18", label: "Other taxes", prefix: "oth_tax" },
  { line: "19", label: "Federal income tax withheld", prefix: "fed_tax" },
  { line: "20", label: "Payments", prefix: "payment" },
];

const COLS: { key: string; label: string }[] = [
  { key: "jnt_ret", label: "Shown on joint return" },
  { key: "inj_sp", label: "Allocated to injured spouse" },
  { key: "oth_sp", label: "Allocated to other spouse" },
];

/**
 * Part III — Allocation grid (legacy `isa_part3.php`). Nine line items across
 * three columns; each money cell shows a live thousands-separator and stores the
 * raw number (server strips separators). Row 16 (exemptions) is a whole count.
 * Values are transcribed as typed — no column-sum recompute. Terminal tab.
 */
export function IsaPart3() {
  return (
    <Card className="gap-0 overflow-hidden overflow-x-auto p-0">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-72">Line item</TableHead>
            {COLS.map((c) => (
              <TableHead key={c.key} className="text-right">
                {c.label}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {ROWS.map((row) => (
            <TableRow key={row.prefix}>
              <TableCell className="text-sm">
                <span className="text-muted-foreground mr-2 font-mono">{row.line}</span>
                {row.label}
              </TableCell>
              {COLS.map((c) => {
                const name = `${row.prefix}_${c.key}`;
                return (
                  <TableCell key={c.key}>
                    <FormikMoneyCell
                      name={name}
                      integer={row.integer}
                      aria-label={`${row.label} — ${c.label}`}
                    />
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
